import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8ed29c41.js';
import './chunk-75a5af93.js';
import './chunk-d92f0cd9.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { S as Select } from './chunk-83eb0d37.js';
export { S as BSelect } from './chunk-83eb0d37.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Select);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/dist/esm/select.js
// module id = null
// module chunks = 